import { useCallback } from "react";

import classnames from "classnames";

import useEmblaCarousel from "embla-carousel-react";
import Autoplay from "embla-carousel-autoplay";
import { FaChevronCircleLeft, FaChevronCircleRight } from "react-icons/fa";

import { useEffect, useState } from "react";
import { collection, getDocs, query } from "firebase/firestore";
import { db } from "../../util/firebase";

export function EmblaCarousel() {
  const [emblaRef, emblaApi] = useEmblaCarousel({ loop: false }, [Autoplay()]);

  const scrollPrev = useCallback(() => {
    if (emblaApi) emblaApi.scrollPrev();
  }, [emblaApi]);

  const scrollNext = useCallback(() => {
    if (emblaApi) emblaApi.scrollNext();
  }, [emblaApi]);

  const [banners, setBanners] = useState([]);

  // Loading state declared early so fetchBanners can reference it reliably
  const [isLoading, setIsLoading] = useState(true);

  const BANNERS_CACHE_KEY = "homePageBanners_v1";
  const BANNERS_CACHE_TTL_MS = 1000 * 60 * 60; // 1 hour

  const fetchBanners = async () => {
    try {
      setIsLoading(true);

      // Try cache first
      try {
        const cachedRaw = localStorage.getItem(BANNERS_CACHE_KEY);
        if (cachedRaw) {
          const cached = JSON.parse(cachedRaw);
          if (
            cached?.timestamp &&
            Date.now() - cached.timestamp < BANNERS_CACHE_TTL_MS
          ) {
            setBanners(cached.banners || []);
            setIsLoading(false);
            return;
          }
        }
      } catch (e) {
        // ignore cache errors
      }

      let fetchedBanners = [];

      const q = query(collection(db, "homePageBanners"));
      const docs = await getDocs(q);
      docs.forEach((doc) => {
        const newBanner = doc.data();

        fetchedBanners.push(newBanner);
      });

      fetchedBanners.sort(
        (a, b) => new Date(a.dateAdded) - new Date(b.dateAdded)
      );

      setBanners(fetchedBanners);

      // cache for future loads
      try {
        localStorage.setItem(
          BANNERS_CACHE_KEY,
          JSON.stringify({ banners: fetchedBanners, timestamp: Date.now() })
        );
      } catch (e) {
        // ignore cache write errors
      }

      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching banners");
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchBanners();
    // eslint-disable-next-line
  }, []);

  if (isLoading) {
    return (
      <div className="embla">
        <div className="embla__container">
          <div className="embla__slide first">
            <img
              className="heroBannerContainer"
              alt="heroImage"
              src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fheros%2F1836X1500%20Nico.png?alt=media&token=032174e2-bc95-4fec-acdc-485374a673e9"
            />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="embla" ref={emblaRef}>
      <div className="embla__container">
        {banners.map((banner, index) => (
          <div
            key={banner.uid || banner.id || index}
            className={classnames("embla__slide", {
              first: index !== banners.length - 1,
            })}
          >
            <img
              className="heroBannerContainer"
              alt={banner.alt || `heroImage-${index}`}
              src={banner.url}
              loading="lazy"
            />
          </div>
        ))}
        {/* <div className="embla__slide first">
					<img
            className='heroBannerContainer'
            alt="heroImage"
            src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fheros%2FB01-ENG-1900X15001.png?alt=media&token=016d9df0-66cd-4f59-83f8-2ebc42c2d905"
          />
				</div>
        <div className="embla__slide first">
					<img
            className='heroBannerContainer'
            alt="heroImage"
            src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fheros%2FmlbHero.png?alt=media&token=ca4c4900-029a-4b1a-9634-f7ac106af6cb"
          />
				</div>
				<div className="embla__slide first">
					<img
            className='heroBannerContainer'
            alt="heroImage"
            src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fheros%2F1900x1500%20formula%2001.png?alt=media&token=1af312ff-1496-4f97-bd49-e6bc42140cd8"
          />
				</div>
        <div className="embla__slide">
					<img
            className='heroBannerContainer'
            alt="heroImage"
            src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fheros%2FB03-ENG-1900X1500.png?alt=media&token=9842d674-b0cc-4b84-b3de-4019ec8146a3"
          />
				</div> */}
      </div>
      <div id="emblaCarouselNavContainer">
        <FaChevronCircleLeft className="embla__prev" onClick={scrollPrev} />
        <FaChevronCircleRight className="embla__next" onClick={scrollNext} />
      </div>
    </div>
  );
}
